// @ts-nocheck
import React from 'react';
import Meetings from 'components/access/Meetings';

const PenlyAccessMeetings = () => (
    <Meetings />
);

export default PenlyAccessMeetings;
